import { defineMessages } from 'react-intl';

/**
 * Intl messages for the non-binding-estimate disclaimer shown below the
 * bottom action row on the Estimate (step 3) and Summary (step 5) screens.
 *
 * The apostrophe is the U+2019 curly form rather than `&rsquo;`: the copy now
 * flows through ICU MessageFormat, where an HTML entity would render
 * literally. A straight `'` would also be wrong — ICU treats it as an escape
 * character.
 */
export const messages = defineMessages({
	disclaimer: {
		id: 'ubp.calculator.estimateDisclaimer',
		defaultMessage:
			'This estimate isn’t binding for either you or Atlassian. Figures shown here are intended to show an estimation of usage allowance, and may be subject to change.',
	},
});
